<template>
  <RouterLink :to="social.link" target="_blank" :data-test="social.icon">
    <UiIcon :icon="`$${social.icon}Outline`" />
  </RouterLink>
</template>

<script setup lang="ts">
import { UiIcon } from '~/ui';
import { type Social } from '~/domains/core';
import { RouterLink } from '~/infrastructure';

export interface Props {
  social: Social;
}
defineProps<Props>();
</script>
